import moment from 'moment';
import i18n from 'l10n';
import Handlebars from 'handlebars';

    var it = {};
    var toText = function (n, len) {
        if (!len)
            len = 4;
        var text = "" + n;
        if (text.length <= len)
            return text;
        else
            return "<small>" + text + "</small>";
    };
    it.init = function (selector, selector1) {
        var handler = function (json) {
            $(selector).find("#contact-count-1").show().html(toText(json,6));
            $(selector).find("#contact-text").show().text(i18n.t('dashboard.contacts', { count : json }));
            var cl = Handlebars.helpers.dynamicFontSize(json,
                $(selector).find("#contact-count-1").data("font-length"));
            $(selector).find("#contact-count-1").addClass(cl.toString());
            $(selector).find("#contact-text-title").text(i18n.t("dashboard.contacts", { count : json }));
        };
        $.getDefaultJSONQ('/CampaignCloud/Subscription/count', null, handler);
        var handlerBlocked = function (json) {
            $(selector).find("#contact-blocked-title").text(i18n.t("dashboard.blocked", { count : json }));
            var cl = Handlebars.helpers.dynamicFontSize(json,
                $(selector).find("#blocked-count").data("font-length"));
            $(selector).find("#blocked-count").addClass(cl.toString());
            $(selector).find("#blocked-count").text(json);

        };
        $.getDefaultJSONQ('/CampaignCloud/Group/1/count', null, handlerBlocked);
        var handlerGroupCounter = function (json) {
            $(selector).find("#group-count_1").show().text(json);
            var cl = Handlebars.helpers.dynamicFontSize(json,
                $(selector).find("#group-count_1").data("font-length"));
            $(selector).find("#group-count_1").addClass(cl.toString());
            $(selector).find("#group-text").text(i18n.t("dashboard.groups", { count : json }));

        };
        $.getDefaultJSONQ('/CampaignCloud/Group/countGroups', null, handlerGroupCounter);
    };
    export default it;
